import { SearchOutlined, SendOutlined } from '@ant-design/icons';
import { layDsNLDTheoIdDonVi, layLanhDaoPhuTrachPhongTheoDonVi } from '@app/services/nhanvien';
import { Button, Col, DatePicker, DatePickerProps, Input, Row, Space, Table, Tabs, Tooltip } from 'antd';
import Column from 'antd/es/table/Column';
import ColumnGroup from 'antd/es/table/ColumnGroup';
import dayjs, { Dayjs } from 'dayjs';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { ContentHeader } from "../../components";
import ModalTextForm from '../../components/modal/ModalTextForm';
import { idQuyDauTu, trangThaiKPI } from '../../constants';
import { Links } from '../../helpers/Links';
import { menuHelper } from '../../helpers/account';
import { dateCommon } from '../../helpers/common';
import { KPIPhongBanPagingResponse, KPIPhongBanResponse, KPIThang } from '../../models/kpi/KPIPhongBan';
import ContainerDonViPhuTrach from '../../modules/department/ContainerDonViPhuTrach';
import { lanhDaoPhongTrinhKPI, layTongHopKPIThang, timKiemDSKPIDuyet } from '../../services/kpi';
import { hideLoadingScreen, showLoadingScreen } from '../../store/reducers/loading';
import ModalTongHopLoiViPham from './ModalTongHopLoiViPham';
import QuanLyTieuDeKPI from './QuanLyTieuDeKPI';
import TabKetQuaHoanThanh from './TabKetQuaHoanThanh';
import TrangThaiTag from './TrangThaiTag';
import { getXepLoai, getXepLoaiByDiemDanhGia } from './kpiHelper';
const DuyetKPIPhongBan = () => {
    const dispatch = useDispatch();
    const menu: any = menuHelper.checkMultiPermission([
        Links.KPI.ChiTietKPI,
        Links.KPI.LanhDaoPhongDuyet
    ]);
    const [activeTab, setActiveTab] = useState<string>("1");
    const [reloadPage, setReloadPage] = useState<boolean>(true);
    const [isLoadingTable, setIsLoadingTable] = useState<boolean>(false);
    const [openModalLoiViPham, setOpenModalLoiViPham] = useState<boolean>(false);
    const [confirmModal, setConfirmModal] = useState<any>({});
    const [idDonVi, setIdDonVi] = useState<number>(idQuyDauTu);
    const [tuKhoa, setTuKhoa] = useState<string>("");
    const [idDonViCV, setIdDonViCV] = useState<number>(idQuyDauTu);
    const [tuKhoaCV, setTuKhoaCV] = useState<string>("");
    let ngayHienTai = (dayjs()).date() <= 10 ? (dayjs()).subtract(1, 'month') : dayjs();
    let thangHienTai = ngayHienTai.startOf('month').format('DD/MM/YYYY HH:mm:ss'); 
    const [thangNam, setThangNam] = useState<string>(thangHienTai);
    const [ngayThang, setNgayThang] = useState<Dayjs | null>(ngayHienTai);
    const monthFormat = 'MM/YYYY';
    const thangNamFormat: DatePickerProps['format'] = (value) => `Tháng ${value.format(monthFormat)}`;
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
    const [selectedRows, setSelectedRows] = useState<Array<KPIPhongBanResponse>>([]);
    const [data, setData] = useState<Array<KPIPhongBanResponse>>([]);
    const [danhsach, setDanhSach] = useState<KPIPhongBanPagingResponse>({
        "data": [],
        "nhanViens": []
    });
    const [tongHopKPI, setTongHopKPI] = useState<KPIThang | null>(null);
    const user = useSelector((state: any) => state.auth.currentUser);

    const [openModalChiTiet, setOpenModalChiTiet] = useState(false);
    const [hasLDPhuTrach, setHasLDPhuTrach] = useState(false);
    const onChange: DatePickerProps['onChange'] = (date) => {
        var dateStr = date?.startOf('month').format('DD/MM/YYYY HH:mm:ss');
        setNgayThang(date);
        if (dateStr) {
            setThangNam(dateStr);
            timkiem(idDonVi, tuKhoa, dateStr);
            layThongTinKPIThang(date?.startOf('month').format('MM/YYYY') || "");
        } else {
            setThangNam("");
            timkiem(idDonVi, tuKhoa, "");
            setTongHopKPI(null);
        }
    }

    const layLanhDaoPhuTrach = async () => {
        var ldPhuTrach = await layLanhDaoPhuTrachPhongTheoDonVi(user.idDonVi);
        if (ldPhuTrach != null && ldPhuTrach.id > 0) {
            setHasLDPhuTrach(true);
        } else {
            setHasLDPhuTrach(false);
        }
    }

    const layThongTinKPIThang = async (thangNam: string) => {
        dispatch(showLoadingScreen());
        var rs = await layTongHopKPIThang(thangNam);
 
        setTongHopKPI(rs);
        dispatch(hideLoadingScreen());
    }

    const onChangeDepartment = (e: any) => {
        if (e) {
            setIdDonVi(e.id);
            timkiem(e.id, tuKhoa, thangNam);
        } else {
            setIdDonVi(0);
            setData([]);
            setDanhSach({
                "data": [],
                "nhanViens": []
            });
        }
    };

    const containerDepartmentProps = {
        showHeader: false,
        onChange: onChangeDepartment,
        value: idDonVi
    }

    const timkiem = async (idDonVi: number, tuKhoa: string, thangNam: string) => {
        try {
            setIsLoadingTable(true);
            const temp = await timKiemDSKPIDuyet(idDonVi, tuKhoa, thangNam);
            setData((temp?.data || []).map((item: any) => {
                return { ...item, key: item.idKPICaNhan }
            }));
            setDanhSach({
                "data": (temp?.data || []).map((item: any) => {
                    return { ...item, key: item.idKPICaNhan }
                }),
                "nhanViens": (temp?.nhanViens || []).map((item: any) => {
                    return { ...item, key: item.idNhanVien }
                })
            });
            setIsLoadingTable(false);
        }
        catch (error: any) {
            setIsLoadingTable(false);
        };
    }

    const eventTrinhKPI = async () => {
        var dsNhanVien = await layDsNLDTheoIdDonVi(user.idDonVi);
        var dsNhanVienThieuKPI = dsNhanVien.filter(nhanVien =>
            !data.some(kpi => kpi.idNhanVien === nhanVien.id)
        ).map(nhanvien => nhanvien.hoTen)
        setConfirmModal({
            isShowModal: true,
            title: "Trình KPI",
            content:
                <>
                    {dsNhanVienThieuKPI.length > 0 && <p> <label>Danh sách nhân viên còn thiếu KPI:</label> {dsNhanVienThieuKPI.join(", ")}.</p>}
                    Bạn có muốn <label>Trình</label> danh sách KPI này không?
                </>,
            onSubmit: trinhKPI
        });
    }

    const trinhKPI = async () => {
        dispatch(showLoadingScreen());
        try {
            var request = {
                thangNam: ngayThang,
                idKPIs: data.filter(kpi => (kpi.idNhanVien == user.idNhanVien && (kpi.trangThai == trangThaiKPI.khoiTao || kpi.trangThai == trangThaiKPI.thuHoi || (hasLDPhuTrach && kpi.trangThai == trangThaiKPI.lanhDaoPhuTrachTuChoi))) 
                || (kpi.lanhDaoPhong != null && kpi.trangThai == trangThaiKPI.trinhLanhDaoPhong|| (hasLDPhuTrach &&kpi.trangThai == trangThaiKPI.lanhDaoPhuTrachTuChoi) || (!hasLDPhuTrach &&kpi.trangThai == trangThaiKPI.lanhDaoDonViTuChoi))).map(x => x.idKPICaNhan)
            };
            
            await lanhDaoPhongTrinhKPI(request);
            toast.success("Trình KPI thành công");
            setReloadPage(true);
        } catch (ex) {
            toast.error("Trình KPI không thành công");
        }
        dispatch(hideLoadingScreen());
    }

    const layClassName = (value: any) => {
        let result = "btn-primary";

        if ((value.lanhDaoPhong != null && !(value.trangThai == trangThaiKPI.lanhDaoPhongTuChoi))
            || (value.lanhDaoPhong == null && value.tuDanhGia != null && user.idNhanVien == value.idNhanVien)) {
            result = "btn-success";
        }

        return result;
    }
    
    useEffect(() => {
        layLanhDaoPhuTrach();
    }, [])

    useEffect(() => {
        const params = new URLSearchParams(window.location.search)
        let idDV = +(params.get('idDonVi') || '');
        if(idDV > 0){
            setIdDonVi(+idDV);
        }
        let thangNamParams = (params.get('thangNam') || '');
        var thangNamDayjs = dateCommon.convertThangNamToDayjs(thangNamParams);
        var dateStr = "";
        if (thangNamDayjs != null) {
            dateStr = thangNamDayjs?.startOf('month').format('DD/MM/YYYY HH:mm:ss');
            setNgayThang(thangNamDayjs);
            setThangNam(dateStr);
        }
        if (reloadPage) {
            setData([]);
            setDanhSach({
                "data": [],
                "nhanViens": []
            });
            timkiem(idDV > 0 ? idDV : idDonVi, tuKhoa, dateStr!= "" ? dateStr : thangNam);
            layThongTinKPIThang(thangNamDayjs != null ? thangNamParams : ngayThang?.format('MM/YYYY') || "");
            setSelectedRowKeys([]);
            setSelectedRows([]);
            setReloadPage(false);
        }
    }, [reloadPage]);

    const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Enter') {
            timkiem(idDonVi, tuKhoa, thangNam);
        }
    };
    return (<section>
        <ContentHeader title="Duyệt KPI" />
        <ModalTongHopLoiViPham
            show={openModalLoiViPham}
            thangNam={thangNam}
            onClose={() => setOpenModalLoiViPham(false)}
        />
        {activeTab != "2" ?
            <Row className="form-group" gutter={8}>
                <Col span={4}>
                    <DatePicker
                        changeOnBlur={true}
                        allowClear={false}
                        value={ngayThang}
                        style={{ width: "100%" }}
                        placeholder="Tháng đánh giá"
                        picker="month"
                        format={thangNamFormat}
                        onChange={onChange} />
                </Col>
                <Col span="7">
                    <ContainerDonViPhuTrach {...containerDepartmentProps} />
                </Col>
                <Col span={7}>
                    <Input prefix={<SearchOutlined rev="" />} allowClear value={tuKhoa} placeholder="Nhập tên, mã nhân viên" onChange={(e) => setTuKhoa(e.target.value)}
                        onKeyPress={handleKeyPress} />
                </Col>
                <Col span={3}>
                    <Space>
                        <Button type="primary" icon={<SearchOutlined rev="" />} onClick={() => {
                            if (activeTab === "1") {
                                timkiem(idDonVi, tuKhoa, thangNam);
                                layThongTinKPIThang(ngayThang?.format('MM/YYYY') || "");
                            }
                        }}>
                            Tìm kiếm
                        </Button>
                    </Space>
                </Col>
                <Col span={3}>
                    {
                        // button của Lãnh đạo phòng
                        menu[Links.KPI.LanhDaoPhongDuyet] && user.isLanhDaoPhong && data.length > 0 && data.some(kpi => (kpi.idNhanVien == user.idNhanVien && (kpi.trangThai == trangThaiKPI.khoiTao || kpi.trangThai == trangThaiKPI.thuHoi || kpi.trangThai == trangThaiKPI.lanhDaoPhuTrachTuChoi)) || ((kpi.trangThai === trangThaiKPI.trinhLanhDaoPhong || (hasLDPhuTrach && kpi.trangThai === trangThaiKPI.lanhDaoPhuTrachTuChoi) || (!hasLDPhuTrach && kpi.trangThai === trangThaiKPI.lanhDaoDonViTuChoi)))) &&
                        data.every(kpi => kpi.lanhDaoPhong != null || (kpi.idNhanVien == user.idNhanVien)) &&
                        <Button
                            type="primary"
                            icon={<SendOutlined rev="" />}
                            className="hrm-btn float-right"
                            onClick={eventTrinhKPI}
                        >
                            Trình
                        </Button>
                    }
                </Col>
            </Row>
            : <Row className="form-group" gutter={8}>
                <Col span="6">
                    <ContainerDonViPhuTrach value={idDonViCV} onChange={(e) => { setIdDonViCV(e.id) }} />
                </Col>
                <Col span={6}>
                    <Input allowClear prefix={<SearchOutlined rev="" />} placeholder="Nhập tên để tìm kiếm" onChange={(e) => setTuKhoaCV(e.target.value)} />
                </Col>
            </Row>}
        <Tabs activeKey={activeTab}
            onChange={(key) => { setActiveTab(key);}}
            items={[
                {
                    key: '1',
                    label: "Duyệt KPI",
                    children: <>
                        <Row className="form-group" gutter={8}>
                            <Col span={24}>
                                <TabKetQuaHoanThanh
                                    danhsach={danhsach} anThongKe
                                    tongHopKPI={tongHopKPI}
                                    menu={menu}
                                    user={user}
                                    setOpenModalChiTiet={setOpenModalChiTiet}
                                />
                            </Col>
                        </Row>
                        <Row gutter={8}>
                            <Col span="24">
                                <div className="card card-primary">
                                    <Row>
                                        <Col span="24">
                                            <Space className="float-right" style={{ marginBottom: 8, padding: '0 8px', fontSize: '12px', fontStyle: "italic", fontFamily: '"Times New Roman", Times, serif' }}>
                                                <span style={{ fontWeight: 600 }}>Chú thích nút Xem:</span>
                                                <Space size={4}>
                                                    <span className="hrm-btn hrm-btn-sm btn-primary" style={{ width: 16, height: 16, display: 'inline-block', borderRadius: 3 }} />
                                                    <span>Chưa đánh giá</span>
                                                </Space>
                                                <Space size={4}>
                                                    <span className="hrm-btn hrm-btn-sm btn-success" style={{ width: 16, height: 16, display: 'inline-block', borderRadius: 3 }} />
                                                    <span>Đã đánh giá</span>
                                                </Space>
                                            </Space>
                                        </Col>
                                        <Col span="24">
                                            <Table
                                                loading={isLoadingTable}
                                                locale={{ emptyText: "Không có dữ liệu" }}
                                                dataSource={data}
                                                pagination={false}
                                                sticky
                                                scroll={{ x: 1200 }}
                                            >
                                                <Column title="Tên nhân viên" dataIndex="hoTen" key="hoTen" width="200px" fixed />
                                                <Column title="Chức vụ" dataIndex="tenChucVu" key="tenChucVu" fixed />
                                                <ColumnGroup title="Cá nhân tự xếp loại" key="canhan">
                                                    <Column title="Tổng điểm" dataIndex="tuDanhGia" key="tuDanhGia" align="center" />
                                                    <Column title="Xếp loại" dataIndex="tuDanhGia" key="tuDanhGiaXL" align="center" render={(value: any, record: any) => {
                                                        return record.tuDanhGia != null ? getXepLoaiByDiemDanhGia(record.tuDanhGia, record.tuDanhGiaCM) : "";
                                                    }} />
                                                </ColumnGroup>
                                                <ColumnGroup title="Xếp loại của LĐ phòng nghiệp vụ" key="ldpnv">
                                                    <Column title="Tổng điểm" dataIndex="lanhDaoPhong" key="lanhDaoPhong" align="center" />
                                                    <Column title="Xếp loại" dataIndex="lanhDaoPhong" key="lanhDaoPhongXL" align="center" render={(value: any, record: any) => {
                                                        return record.lanhDaoPhong != null ? getXepLoaiByDiemDanhGia(record.lanhDaoPhong, record.lanhDaoPhongCM) : "";
                                                    }} />
                                                </ColumnGroup>
                                                <ColumnGroup title="Ý kiến của Phó Giám đốc" key="pgd">
                                                    <Column title="Tổng điểm" dataIndex="lanhDaoPhuTrach" key="lanhDaoPhuTrach" align="center" />
                                                    <Column title="Xếp loại" dataIndex="lanhDaoPhuTrach" key="lanhDaoPhuTrachXL" align="center" render={(value: any, record: any) => {
                                                        return record.lanhDaoPhuTrach != null ? getXepLoaiByDiemDanhGia(record.lanhDaoPhuTrach, record.lanhDaoPhuTrachCM) : "";
                                                    }} />
                                                </ColumnGroup>
                                                <ColumnGroup title="Phê duyệt của Giám đốc" key="gd">
                                                    <Column title="Tổng điểm" dataIndex="diemDanhGia" key="diemDanhGia" align="center" />
                                                    <Column title="Xếp loại" dataIndex="lanhDaoDonVi" key="lanhDaoDonVi" align="center"
                                                        onCell={(record, rowIndex) => {
                                                            return {
                                                                onClick: (event) => {
                                                                    event.stopPropagation();
                                                                },
                                                            };
                                                        }}
                                                        render={(value: any, record: any, index: number) => {
                                                            return getXepLoai(record.lanhDaoDonVi)
                                                        }}
                                                    />
                                                </ColumnGroup>
                                                <Column title="Tổng số lỗi trong năm" dataIndex="tongSoLoi" key="tongSoLoi" align="center" />
                                                <Column title="" dataIndex="action" key="action"
                                                    fixed='right'
                                                    onCell={(record, rowIndex) => {
                                                        return {
                                                            onClick: (event) => {
                                                                event.stopPropagation();
                                                            },
                                                        };
                                                    }}
                                                    render={(value: any, record: any) => {
                                                        const btn = <Link key={record.idKPICaNhan} className={"hrm-btn hrm-btn-sm " + layClassName(record)} to={Links.KPI.ChiTietKPI + "?id=" + record.idKPICaNhan}>Xem</Link>;
                                                        if (!record.yKien) {
                                                            return btn;
                                                        }
                                                        return <Tooltip
                                                            title={<span style={{ whiteSpace: 'pre-wrap' }}>{record.yKien}</span>}
                                                            overlayStyle={{ maxWidth: 400 }}
                                                        >
                                                            {btn}
                                                        </Tooltip>;
                                                    }}
                                                />
                                            </Table>
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>
                    </>
                },
                {
                    key: '2',
                    label: "Quản lý công việc",
                    children: <QuanLyTieuDeKPI tuKhoa={tuKhoa} isEdit idDonVi={idDonViCV} />
                }
            ]} />


        <ModalTextForm
            show={confirmModal.isShowModal}
            title={confirmModal.title}
            handleClose={() => setConfirmModal({ isShowModal: false })}
            handleSave={() => {
                confirmModal.onSubmit();
                setConfirmModal({ isShowModal: false });
            }}
        >
            {confirmModal.content}
        </ModalTextForm>
        <ModalTextForm
            dialogClassName={"modal-80wh"}
            show={openModalChiTiet.isShowModal}
            title={
                <>
                    Chi tiết kết quả tự đánh giá trong tháng
                    {openModalChiTiet.tenDonVi ? <span> - <strong>{openModalChiTiet.tenDonVi}</strong></span> : ''}
                </>
            }
            handleClose={() => setOpenModalChiTiet({ isShowModal: false, data: [] })}
            hideFooter
        >
            <Row>
                <Col span={24}>
                    <Table
                        loading={isLoadingTable}
                        locale={{ emptyText: "Không có dữ liệu" }}
                        dataSource={openModalChiTiet?.data}
                        pagination={false}
                        sticky
                        scroll={{ x: 1000 }}
                    >
                        <Column title="Tên nhân viên" dataIndex="hoTen" key="hoTen" width="200px" fixed />
                        <Column title={
                            <span style={{
                                fontWeight: 700,
                                color: '#1e40af'
                            }}>
                                Kết quả công việc
                            </span>
                        }>
                            <Column title="Trước" width="65px" dataIndex="truoc" key="truoc" align="center"
                                render={(_, record) => record.truoc} />
                            <Column title="Đúng" width="65px" dataIndex="dung" key="dung" align="center" render={(_, record) => record.dung} />
                            <Column title="Đang TH" width="65px" dataIndex="dangThucHien" key="dangThucHien" align="center" render={(_, record) => record.dangThucHien} />
                            <Column title="Trễ" width="65px" dataIndex="tre" key="tre" align="center" render={(_, record) => record.tre} />
                        </Column>
                        <Column title="Điểm cộng" width="74px" dataIndex="diemCong" key="diemCong" align="center"
                            render={(_, i) => i.lanhDaoPhuTrachDiemCong > 0 ? i.lanhDaoPhuTrachDiemCong : i.lanhDaoPhongDiemCong > 0 ? i.lanhDaoPhongDiemCong : i.tuDanhGiaDiemCong}
                        />
                        <Column title={
                            <span style={{
                                fontWeight: 700,
                                color: '#1e40af'
                            }}>
                                Điểm đánh giá
                            </span>
                        }>
                            <Column title="TĐG" width="65px" dataIndex="tuDanhGia" key="tuDanhGia" align="center" />
                            <Column title="LĐP" width="65px" dataIndex="lanhDaoPhong" key="lanhDaoPhong" align="center" />
                            <Column title="LĐPT" width="72px" dataIndex="lanhDaoPhuTrach" key="lanhDaoPhuTrach" align="center" />
                            <Column title="LĐĐV" width="74px" dataIndex="diemDanhGia" key="diemDanhGia" align="center" />
                        </Column>
                        <Column
                            title="Xếp loại"
                            width="74px"
                            key="xepLoai"
                            align="center"
                            render={(_, record) => record.xepLoai || record.xepLoaiDuKien}
                        />
                        <Column title="Lỗi năm" width="74px" dataIndex="tongSoLoi" key="tongSoLoi" align="center" />
                        <Column title="TT" width="48px" dataIndex="trangThai" key="trangThai" align="center" render={(value, record) => {
                            return <TrangThaiTag value={record.trangThai} noText />
                        }} />
                        <Column title="Thao tác" dataIndex="action" key="action" width="75px"
                            fixed='right' render={(value: any, record: any) => {
                                return <Space className="float-right">
                                    <Link target="_blank" style={{ padding: '2px 8px', fontSize: '13px', minWidth: '28px' }}
                                        rel="noopener noreferrer"
                                        className="hrm-btn hrm-btn-sm btn-primary" to={Links.KPI.ChiTietKPI + "?id=" + record.idKPICaNhan}>Xem</Link>
                                </Space>
                            }} />
                    </Table>
                </Col>
            </Row>
        </ModalTextForm>
    </section>
    );
};

export default DuyetKPIPhongBan;
